import type { TAppUser } from '@core/backend'
import { queryClient } from '@core/query'

import { SessionQueryKey } from '../helpers/queryKeys'

let userAtLoad: TAppUser | null = null

export const seedCurrentUser = (user: TAppUser) => {
    userAtLoad = user
    queryClient.setQueryData(SessionQueryKey.me(), user)
}

export const getUserAtLoad = (): TAppUser | null => userAtLoad
